// extracted by mini-css-extract-plugin
module.exports = {"heading":"signin_heading__26IYe","input":"signin_input__O0jwx","forgot":"signin_forgot__1yjzn","signup":"signin_signup__1HuHh"};